const OnlineOrder = {
    pendingOrder: () => "admin/e-commerce/orders",
    updatedOnlineOrder:(id:string)=>`admin/e-commerce/orders/${id}`,
    downloadOnlineOrder:(id:string)=>`admin/e-commerce/orders/download-receipt/${id}`,
}

export default OnlineOrder